module.exports = __webpack_public_path__ + "img/equatorial-grid.36d79dc6.png";